var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.04102L6.125 10.2077V22.4577C6.125 33.7889 13.965 44.3852 24.5 46.9577C35.035 44.3852 42.875 33.7889 42.875 22.4577V10.2077L24.5 2.04102ZM30.7883 32.666L24.5 28.8889L18.2321 32.666L19.8858 25.5202L14.3529 20.7427L21.6621 20.1098L24.5 13.3723L27.3379 20.0893L34.6471 20.7223L29.1142 25.5202L30.7883 32.666Z",
    fill: "#B7C526"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerLogo);
export default __webpack_public_path__ + "static/media/WinnerLogo.fbb78ce5051ded0a3b051b011103d1ab.svg";
export { ForwardRef as ReactComponent };